import { loadable } from '../../components/loadable';

export const LoadableInstitutionSettings = loadable(
  () => import('./component'),
  {
    key: 'HotInstitutionSettings',
  }
);
